import LoadingComponent from "../../elements/loading/index.jsx";
import {LoadingWrapper} from "./style.js";

export const LoadingPage = ({state}) => {
  return (
    <LoadingWrapper state={state}>
      <LoadingComponent />
    </LoadingWrapper>
  );
};
